import ModalAfterSale from './ModalAfterSale'

export default ModalAfterSale
